(function () {
  function updateIndicator(section) {
    const tabsWrap = section.querySelector('.s1-2wd-features-tabs-v2__tabs-wrap');
    const tabs = section.querySelector('.s1-2wd-features-tabs-v2__tabs');
    const indicator = section.querySelector('.s1-2wd-features-tabs-v2__tabs-indicator');
    const activeTab = section.querySelector('.s1-2wd-features-tabs-v2__tab.is-active');

    if (!tabsWrap || !tabs || !indicator || !activeTab) return;

    const wrapRect = tabsWrap.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    const left = tabRect.left - wrapRect.left;
    const width = tabRect.width;

    indicator.style.width = `${width}px`;
    indicator.style.transform = `translateX(${left}px)`;
  }

  function activateTab(section, index) {
    const tabs = section.querySelectorAll('.s1-2wd-features-tabs-v2__tab');
    const panels = section.querySelectorAll('.s1-2wd-features-tabs-v2__panel-item');

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    updateIndicator(section);
  }

  function initSection(section) {
    if (section.dataset.tabsV2Inited === 'true') return;
    section.dataset.tabsV2Inited = 'true';

    const tabs = section.querySelectorAll('.s1-2wd-features-tabs-v2__tab');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.tabIndex);
        if (Number.isNaN(index)) return;

        activateTab(section, index);

        if (window.innerWidth <= 768) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    const tabsScroller = section.querySelector('.s1-2wd-features-tabs-v2__tabs');
    if (tabsScroller) {
      tabsScroller.addEventListener('scroll', () => updateIndicator(section), { passive: true });
    }

    updateIndicator(section);

    const onResize = () => updateIndicator(section);
    window.addEventListener('resize', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateIndicator).catch(() => {});
    }
  }

  function boot() {
    document.querySelectorAll('.s1-2wd-features-tabs-v2').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.s1-2wd-features-tabs-v2').forEach(initSection);
  });
})();
